var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineAndFilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 553,
    height: 553,
    viewBox: "0 0 553 553",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.97559,
    y: 1.97559,
    width: 550.024,
    height: 550.024,
    fill: "#F2F6F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8145,
    y: 184.321,
    width: 459.35,
    height: 45.8354,
    fill: "#B4DDF3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8145,
    y: 322.823,
    width: 459.35,
    height: 45.8354,
    fill: "#B4DDF3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.501789,
    y: 0.501789,
    width: 551.995,
    height: 551.995,
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9609 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M552 529.042L1.0015 529.042",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M552 506.082L1.0015 506.082",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M552 483.124L1.0015 483.124",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M552 460.167L1.0015 460.167",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M552 437.207L1.0015 437.207",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M552 414.248L1.0015 414.248",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M552 391.291L1.0015 391.291",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M552 368.332L1.0015 368.332",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M552 345.375L1.0015 345.374",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M552 322.417L1.0015 322.417",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M552 299.457L1.0015 299.457",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M552 276.5L1.0015 276.5",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M552 253.542L1.0015 253.541",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M552 230.583L1.0015 230.582",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M552 207.625L1.0015 207.625",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M552 184.667L1.0015 184.667",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M552 161.707L1.0015 161.707",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M552 138.75L1.0015 138.75",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M552 115.792L1.0015 115.792",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M552 92.8315L1.0015 92.8315",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M552 69.8745L1.0015 69.8745",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M552 46.9165L1.0015 46.9165",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M552 23.958L1.0015 23.958",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8359 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M161.71 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M230.586 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M299.46 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M368.334 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M437.208 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M506.083 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M529.037 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9131 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M115.789 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M184.664 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M253.538 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M322.414 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M391.29 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M460.163 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M69.874 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M138.749 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M207.625 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M276.499 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M345.374 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M414.25 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M483.124 1V551.998",
    stroke: "#8C9BA0",
    strokeWidth: 0.996421
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8145 185.317H506.165",
    stroke: "#058CD7",
    strokeWidth: 1.99284
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8145 344.744H506.165",
    stroke: "#058CD7",
    strokeWidth: 1.99284
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3163,
    cy: 184.819,
    r: 4.4839,
    fill: "white",
    stroke: "#058CD7",
    strokeWidth: 1.99284
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3163,
    cy: 345.243,
    r: 4.4839,
    fill: "white",
    stroke: "#058CD7",
    strokeWidth: 1.99284
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 506.663,
    cy: 184.819,
    r: 4.4839,
    fill: "white",
    stroke: "#058CD7",
    strokeWidth: 1.99284
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 506.663,
    cy: 345.243,
    r: 4.4839,
    fill: "white",
    stroke: "#058CD7",
    strokeWidth: 1.99284
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineAndFilling);
export default __webpack_public_path__ + "static/media/lineAndFilling.895ea1014f6fc067db2d6a2b21b6d106.svg";
export { ForwardRef as ReactComponent };